import(/* webpackMode: "eager", webpackExports: ["BatchSection"] */ "/vercel/path0/web/components/batch-section.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/node_modules/next/dist/client/link.js");
